import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './Review.css';
import ReviewInfo from './ReviewInfo';

class CreateReview extends Component {
  render() {
    return (
      <div className={styles['splash-page']}>
        <div>
          <ReviewInfo {...this.props} />

          <div className="row">
            <div
              className={`col-md-12 text-right ${
                styles['button-fixed-position']
              }`}
            >
              <button
                onClick={this._onClickRevise}
                className={`btn btn-default btn-lg ${
                  styles['review-button-revise']
                }`}
              >
                Back
              </button>
              <button
                onClick={this._onClickConfirm}
                className={`btn btn-primary btn-lg ${
                  styles['review-button-confirm']
                }`}
              >
                Confirm Program
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _onClickConfirm = e => {
    e.stopPropagation();
    this.props.confirmProgram();
  };

  _onClickRevise = e => {
    e.stopPropagation();
    this.props.revise();
  };
}

CreateReview.propTypes = {
  pointFromSpendingAmount: PropTypes.array.isRequired,
  rewards: PropTypes.array.isRequired,
  spendingAmount: PropTypes.number.isRequired,
  newMemberPoint: PropTypes.number.isRequired,
  revise: PropTypes.func.isRequired,
};

export default CreateReview;
